var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 60,
    viewBox: "0 0 68 60",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 43.5l32.5-40.7c2.5-3.2 7.2-3.7 10.4-1.2 3.2 2.5 3.7 7.2 1.2 10.4 0 0-34.7 43.4-34.6 43.3 -2.3 3.1-6 4.8-9.9 4.7 -3.9-0.1-7.5-2.1-9.5-5.1l-10.8-15.2c-2.4-3.3-1.6-7.9 1.7-10.3 3.3-2.4 7.9-1.6 10.3 1.7l8.8 12.4Z"
  })));
};
export default SvgCheck;